import { CreateActionParams } from '../actions';

export type OnAddonQuantityChange = (
  addonId: string,
  quantity: number,
  serviceSlotId: string,
) => void;

export function createOnAddonQuantityChangeAction({
  getControllerState,
  internalActions: { calculatePaymentDetails, updateServiceSlot },
}: CreateActionParams): OnAddonQuantityChange {
  return async (addonId: string, quantity: number, serviceSlotId: string) => {
    const [state] = getControllerState();
    const { serviceData } = state;
    const slotService = serviceData.slotServices[serviceSlotId];
    const group = slotService.addOnByGroup?.find((g) =>
      g.addOns?.some((a) => a.id === addonId),
    );

    if (!group) {
      return;
    }

    const addon = group.addOns?.find((a) => a.id === addonId);
    if (
      !addon ||
      !addon.maxQuantity ||
      quantity < 1 ||
      quantity > addon.maxQuantity
    ) {
      return;
    }

    const currentSelectedAddons = slotService.selectedAddons || {};
    const selectedAddon = currentSelectedAddons[addonId];
    if (!selectedAddon) {
      return;
    }

    const newSelectedAddons = {
      ...currentSelectedAddons,
      [addonId]: {
        ...selectedAddon,
        quantity,
      },
    };

    updateServiceSlot(
      {
        selectedAddons: newSelectedAddons,
      },
      serviceSlotId,
    );

    await calculatePaymentDetails({});
  };
}
